import { useEffect, useState } from 'react';

// The mask is a sibling of the wrap, and it outlives it during a fade-out — so
// it has to be watched in its own right, or the tutorial calls the screen ready
// while a dimmed layer is still swallowing clicks.
const MODAL_SELECTOR = '.ant-modal-wrap, .ant-modal-mask, ion-modal:not(.overlay-hidden)';

const detect = () =>
  Array.from(document.querySelectorAll(MODAL_SELECTOR)).some((node) => {
    const style = window.getComputedStyle(node);
    if (style.display === 'none' || style.visibility === 'hidden') return false;

    // Ionic leaves an <ion-modal> in the markup for every modal the page can
    // show, and one that has never been opened carries no class to say so. It
    // takes up no room, which is what separates it from a modal that is really
    // covering the app.
    const { width, height } = node.getBoundingClientRect();
    return width > 0 && height > 0;
  });

/**
 * Tracks whether one of the app's own modals is on screen.
 *
 * A modal brings its own dimming mask, so the tutorial drops its backdrop while
 * one is open — otherwise the two stack up and the dialogue reads as greyed out.
 */
const useAppModalOpen = () => {
  const [open, setOpen] = useState(detect);

  useEffect(() => {
    const update = () => setOpen(detect());
    update();

    const observer = new MutationObserver(update);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style'],
    });

    return () => observer.disconnect();
  }, []);

  return open;
};

export default useAppModalOpen;
